import React from 'react';
import { Label } from './ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { FileText, Users, FileSignature, FlaskConical, Sparkles } from 'lucide-react';

const TEMPLATES = [
  {
    value: 'auto',
    label: '🤖 Auto-Detect (Recommended)',
    description: 'AI automatically detects document type'
  },
  {
    value: 'meeting_notes',
    label: '👥 Meeting Notes',
    description: 'Extracts attendees, decisions, action items',
    icon: Users
  },
  {
    value: 'project_brief',
    label: '📋 Project Brief',
    description: 'Goals, timeline, budget, stakeholders',
    icon: FileText
  },
  {
    value: 'contract',
    label: '📄 Contract/Agreement',
    description: 'Terms, obligations, red flags, deadlines',
    icon: FileSignature
  },
  {
    value: 'research_paper',
    label: '🔬 Research Paper',
    description: 'Methodology, findings, data, conclusions',
    icon: FlaskConical
  },
  {
    value: 'general',
    label: '📝 General Document',
    description: 'Comprehensive analysis for any document',
    icon: Sparkles
  }
];

const TemplateSelector = ({ value, onChange, showDescription = true }) => {
  const selectedTemplate = TEMPLATES.find(t => t.value === value) || TEMPLATES[0];

  return (
    <div className="space-y-2">
      <Label className="flex items-center gap-2">
        <Sparkles className="h-4 w-4 text-teal-600" />
        Document Template
      </Label>
      
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Select template...">
            {selectedTemplate.label}
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {TEMPLATES.map((template) => {
            const Icon = template.icon;
            return (
              <SelectItem key={template.value} value={template.value}>
                <div className="flex items-start gap-2">
                  {Icon && <Icon className="h-4 w-4 mt-0.5 text-gray-600" />}
                  <div>
                    <p className="font-medium">{template.label}</p>
                    {showDescription && (
                      <p className="text-xs text-gray-500 mt-0.5">{template.description}</p>
                    )}
                  </div>
                </div>
              </SelectItem>
            );
          })}
        </SelectContent>
      </Select>
      
      {showDescription && selectedTemplate.description && (
        <p className="text-xs text-gray-600 bg-teal-50 p-2 rounded border border-teal-200">
          💡 {selectedTemplate.description}
        </p>
      )}
    </div>
  );
};

export default TemplateSelector;
